import { IContainer } from '../interface/container';

export interface IContainerPrv extends IContainer {
    _map: Map<symbol, any>;
    _parents: Array<IContainer>;
}

export default function Container(): IContainer {
    const container: IContainerPrv = {
        _map: new Map(),
        _parents: [],
        get: function <T>(this: IContainerPrv, key: symbol): T {
            return (this._map.get(key) ??
                this._parents.find(container => container.get(key))?.get(key)) as T;
        },
        bind: function (this: IContainerPrv, key: symbol, value: any) {
            this._map.set(key, value);
        },
        importBindings: function (this: IContainerPrv, container: IContainer) {
            this._parents.unshift(container);
        },
        remove: function (this: IContainerPrv, key: symbol) {
            this._map.delete(key);
        },
    };

    return container as IContainer;
}
